module.exports = __webpack_public_path__ + "static/media/08-_DSC7392.338de84b.jpg";